import useGetPassengerClassColor from "@CheckOrder/features/classPicker/hooks/useGetPassengerClassColor";
import matchPassengerClassTypeAndIcon from "@CheckOrder/features/classPicker/functions/matchPassengerClassTypeAndIcon";
import IconPassengerClass from "@Icons/ticket/passengerClass/IconPassengerClass";
import useCurrency from "@Currency/hooks/useCurrency";
import useGetPassengersName
    from "@CheckOrder/features/classPicker/features/additionalPassengerClassSelectModal/hooks/useGetPassengersName";
import AvailablePassengerClassType from "@CheckOrder/features/classPicker/types/AvailablePassengerClass.type";

interface PassengersInAClassGroupListProps {
    passengerIdsGroup: number[],
    selectedPassengerClass: AvailablePassengerClassType,
    addUserToThisPassengerGroup: (index: number) => () => void
    index: number,
    isReturn: boolean,
}

function PassengersInAClassGroupList(props: PassengersInAClassGroupListProps) {
    const {
        passengerIdsGroup,
        selectedPassengerClass,
        addUserToThisPassengerGroup,
        index,
        isReturn,
    } = props

    const {color} = useGetPassengerClassColor(passengerIdsGroup[0], isReturn)
    const {val} = useCurrency()

    const {getPassengersList} = useGetPassengersName()

    return (

        <button
            type="button"
            onClick={addUserToThisPassengerGroup(index)}
            className="existing-passenger-class"
            style={{
                borderLeft: `4px solid ${color}`,
                borderBottom: `1px solid ${color}`,
                "--existing-passenger-class-color": color,
            }}
        >
            <IconPassengerClass
                title={matchPassengerClassTypeAndIcon(selectedPassengerClass.type)}
                width="24"
                height="24"
            />
            <span className="existing-passenger-class__users">
                {getPassengersList(passengerIdsGroup)}
            </span>
            <span className="price-section">
                <span className="old-price">
                    {`${selectedPassengerClass.prices[passengerIdsGroup.length]} ${val}`}
                </span>
                &nbsp;
                <span className="new-price">
                    {`${selectedPassengerClass.prices[passengerIdsGroup.length + 1]} ${val}`}
                </span>
            </span>
        </button>
    )
}

export default PassengersInAClassGroupList